import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=d4ff0de0&"
import script from "./GroupRow.vue?vue&type=script&lang=js&"
export * from "./GroupRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports